import * as React from "react";
import { useState, PropsWithChildren } from "react";
import Divider from "@material-ui/core/Divider";
import TableChart from "@material-ui/icons/TableChart";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import LockOpen from "@material-ui/icons/LockOpen";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import IconButton from "@material-ui/core/IconButton";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import clsx from "clsx";
import HowToReg from "@material-ui/icons/HowToReg";
import School from "@material-ui/icons/School";
import SupervisorAccount from "@material-ui/icons/SupervisorAccount";
import EmojiFoodBeverage from "@material-ui/icons/EmojiFoodBeverage";
import AssistantIcon from "@material-ui/icons/Assistant";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import MenuBook from "@material-ui/icons/MenuBook";
import { useStyles } from "./Navigation.styles";
import { Routes } from "../../routes/routes";

interface NavigationProps {
  open: boolean;
  onDrawerClose: () => void;
}

interface NavItemProps {
  to: string;
  icon: React.ReactNode;
  title: string;
  className?: string;
  iconClass?: string;
}

const NavItem = ({ to, icon, title, className, iconClass }: NavItemProps) => {
  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps: PropsWithChildren<{}>, ref: any) => <RouterLink to={to} ref={ref} {...itemProps} />),
    [to]
  );
  const routeMatch = useRouteMatch(to);

  return (
    <ListItem button component={renderLink} className={className} selected={routeMatch?.isExact}>
      <ListItemIcon className={iconClass}>{icon}</ListItemIcon>
      <ListItemText primary={title} />
    </ListItem>
  );
};

export function Navigation({ onDrawerClose, open }: NavigationProps) {
  const [expandProfiles, setExpandProfiles] = useState(false);
  const classes = useStyles();

  return (
    <Drawer
      open={open}
      variant="permanent"
      classes={{ paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose) }}
    >
      <div className={classes.toolbarIcon}>
        <IconButton onClick={onDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <Divider />
      <List>
        <NavItem to={`/${Routes.users}`} title={"Пользователи"} icon={<TableChart />} />
        <ListItem button onClick={handleExpandProfilesMenu} selected={expandProfiles}>
          <ListItemIcon>
            <TableChart />
          </ListItemIcon>
          <ListItemText primary="Профили" />
          {expandProfiles ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={expandProfiles} timeout="auto" unmountOnExit>
          <List component={"div"} disablePadding>
            <NavItem
              to={`/${Routes.admins}`}
              icon={<HowToReg />}
              title={"Администраторы"}
              iconClass={classes.buttonIconShift}
            />
            <NavItem
              to={`/${Routes.supervisors}`}
              icon={<SupervisorAccount />}
              title={"Кураторы"}
              iconClass={classes.buttonIconShift}
            />
            <NavItem
              to={`/${Routes.tutors}`}
              icon={<MenuBook />}
              title={"Преподаватели"}
              iconClass={classes.buttonIconShift}
            />
            <NavItem
              to={`/${Routes.students}`}
              icon={<School />}
              title={"Ученики"}
              iconClass={classes.buttonIconShift}
            />
            <NavItem
              to={`/${Routes.parents}`}
              icon={<EmojiFoodBeverage />}
              title={"Родители"}
              iconClass={classes.buttonIconShift}
            />
            <NavItem
              to={`/${Routes.assistants}`}
              icon={<AssistantIcon />}
              title={"Помощники"}
              iconClass={classes.buttonIconShift}
            />
            <NavItem
              to={`/${Routes.contenters}`}
              icon={<BorderColorIcon />}
              title={"Создатели контента"}
              iconClass={classes.buttonIconShift}
            />
          </List>
        </Collapse>
        <NavItem to={`/${Routes.permissions}`} title={"Разрешения"} icon={<LockOpen />} />
      </List>
      <Divider />
    </Drawer>
  );

  function handleExpandProfilesMenu() {
    setExpandProfiles(!expandProfiles);
  }
}
